import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';

import { profilePage } from '@pages/ProfilePage';
import { AnalyticsScreenNames } from '@src/app/utils/analyticsScreenNames';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';
import { loginRequired } from '../utils';

export const loyaltyRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Loyalty.Supercoins,
        name: RouteName.Loyalty.Supercoins,
        components: {
            ...profilePage,
            content: () => import('@app/loyalty/shop/ShopContainer.vue'),
            subnav: loadAsyncWithLoadingState<unknown>(() => import('@app/loyalty/shop/ShopPageHeader.vue')),
            mobileHeader: loadAsyncWithLoadingState<unknown>(() => import('@app/loyalty/shop/ShopPageHeader.vue')),
        },
        beforeEnter: loginRequired(),
        meta: {
            title: Title.Loyalty.Supercoins,
            layoutClass: 'my-account',
            superAnalytics: {
                pageName: AnalyticsScreenNames.loyaltySupercoins,
            },
            mobileHeaderConfig: {
                isContracted: true,
            },
            headerTitle: Title.Loyalty.Supercoins,
        },
    },
];
